import React, { useEffect, useState } from 'react';

import { Result, message } from 'antd';
import { useTranslation } from 'react-i18next';

import { ApiErrorData } from 'models/ApiResponse';

import { VerticalService } from 'services/VerticalService';

import { useThemeLayoutConfig } from 'config/ThemeDashboardLayoutConfig';

import Layout from '../../components/Layout/Layout';
import appI18n from '../../config/i18n';
import { VerticalService as VerticalServiceModel } from '../../models/VerticalService';
import ServiceCard from './Components/ServiceCard';
import ServiceCardSkeleton from './Components/ServiceCardSkeleton';

import './OurServices.scss';

function OurServices() {
  const skeletonCount = 4;
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(true);
  const [verticalServices, setVerticalServices] = useState<
    VerticalServiceModel[]
  >([]);
  const { theme } = useThemeLayoutConfig();
  const { t } = useTranslation(undefined, { i18n: appI18n });

  const styles = {
    emptyState: {
      '--service-primary-color': theme?.token?.colorPrimary,
      '--service-bg-container': theme?.token?.colorBgContainer,
      '--service-text-primary': theme?.token?.colorTextHeading,
      '--service-text-secondary': theme?.token?.colorTextSecondary,
      '--service-border-radius': `${theme?.token?.borderRadiusLG}px`,
    } as React.CSSProperties,
  };

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const verticalResponse = await VerticalService.getByCurrentCompany();

    if (verticalResponse.success) {
      setVerticalServices(verticalResponse.data as VerticalServiceModel[]);
      // messageApi.success(
      //   t('scenes.our_services.scene.messages.fetch_vertical_services_success'),
      //   2.5
      // );
    } else {
      const error = verticalResponse.data as ApiErrorData;
      messageApi.error(
        (error.message as string) ||
          t('scenes.our_services.scene.errors.fetch_vertical_services'),
        3.5
      );
    }

    setLoading(false);
  };

  return (
    <Layout breadcrumbMode="none">
      {contextHolder}

      <div className="my-services-grid-container">
        {loading ? (
          <div className="my-services-grid">
            {Array(skeletonCount)
              .fill(null)
              .map((_, index) => (
                <ServiceCardSkeleton key={`skeleton-${index}`} />
              ))}
          </div>
        ) : verticalServices.length > 0 ? (
          <div className="my-services-grid">
            {verticalServices.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        ) : (
          <div
            className="my-services-empty-container"
            style={styles.emptyState}
          >
            <Result
              status="404"
              title={t('scenes.our_services.scene.empty.title')}
              subTitle={t('scenes.our_services.scene.empty.subtitle')}
            />
          </div>
        )}
      </div>
    </Layout>
  );
}

export default OurServices;
